import { gql } from '@apollo/client'

export const JOB_FILTER_FRAGMENT = gql`
	fragment jobFilter on JobFilter {
		addressCities
		addressStates
		createdBetween
		disciplineIds
		disciplinesCategories
		hotJob
		isPerDiem
		isPerDiemLongTerm
		keyword
		minMatchingPercentage
		nearBy
		payAmountMax
		payAmountMin
		settings
		shifts
		specialtyIds
		startDatetimeBetween
		workTypes
	}
`

// export const NEAR_BY_JOB_SEARCH_FRAGMENT = gql``
